// extracted by mini-css-extract-plugin
export default {"checkIcon":"badge-incomplete_checkIcon__SxyMi","incomplete":"badge-incomplete_incomplete__sTT67"};